<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="label"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="true"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :multiple="isMultiple"
    :hide-selected="true"
    :close-on-select="isCloseOnSelect"
    class="multiselect-primary"
    :preserve-search="isPreserveSearch"
    :clear-on-select="isClearOnSelect"
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="badge badge-primary mr-1">
        <span class="text-truncate mr-1 mb-1">
          {{ `${option.nome} - ${option.nome_esporte}` }}
        </span>
        <span class="custom__remove badge" @mousedown.prevent.stop="remove(option)"> x </span>
      </span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    nameField: {},
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isMultiple: { type: Boolean, default: false },
    reload: {},
    excludeGroups: {},
    idEsporte: {},
    showSportName: { type: Boolean, default: false },
    isCloseOnSelect: { type: Boolean, default: true },
    isPreserveSearch: { type: Boolean, default: false },
    filtrarEsporte: { type: Boolean, default: false },
    isClearOnSelect: { type: Boolean, default: true },
    keyToTrack: { type: String, default: 'id' }
  },

  data() {
    return {
      selected: new Array(),
      options: new Array(),
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_grupo_origem', null);
        return;
      }

      if (this.isMultiple) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_grupo_origem', arr);
      } else {
        this.$emit('selectChange', 'id_grupo_origem', e.id);
      }
      this.$emit('focus');
    },
    label({ nome, nome_esporte }) {
      if (this.isMultiple) {
        if (this.showSportName) {
          return `${nome} - ${nome_esporte}`;
        } else {
          return `${nome}`;
        }
      } else {
        return nome;
      }
    },
    setValue(value) {
      if (this.isMultiple) {
        this.selected = new Array();
        if (value) {
          value.forEach((el) => {
            if (this.filtrarEsporte === true) {
              const foundOption = this.options.find((option) => option[this.keyToTrack] == el);
              if (foundOption) {
                this.selected.push(foundOption);
              }
              return;
            }
            const foundOption = this.options.find((option) => option.id === el || option[this.keyToTrack] == el);
            if (foundOption) {
              this.selected.push(foundOption);
            }
          });
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      } else {
        if (value) {
          this.selected = this.options.find((option) => option.id === value);
          this.reload ? this.$emit('selectChange', 'id_grupo_origem', this.selected.id) : null;
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      }
      this.$emit('input', this.selected);
    },
    setOptions(value = null) {
      this.isLoading = true;

      let filtro =
        'gerencia_grupo_evento.bloqueado is false and gerencia_grupo_evento.id_grupo_origem is not null';

      if (this.filtrarEsporte === true) {
        filtro += ` and gerencia_grupo_evento.id_tipo_esporte = ${this.idEsporte} `;
      } else {
        filtro += ` and templates_odd is not null and (templates_odd::jsonb) @> '[${this.$store.state.user.info.empresa__id_template_odd}]'`;
      }

      let relations = '';
      relations += 'esporte:nome as nome_esporte|';
      relations += 'grupo_origem:nome as nome,id as id';

      this.$atenaList
        .getGerenciaGrupoEventos({
          columns: '*',
          filter: filtro,
          related: relations,
          order: 'nome_grupo_secundario',
          limit: -1
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }

          if (this.filtrarEsporte === true) {
            this.options = this.options.concat(
              res.data.map((o) => {
                return {
                  ...o,
                  id: o[this.keyToTrack]
                };
              })
            );
          } else {
            this.options = this.options.concat(res.data);
          }

          if (this.excludeGroups) {
            this.options = this.options.filter((e) => {
              return !this.excludeGroups.includes(e.id);
            });
          }
          this.setValue(!value ? this.nameField : value);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField(value) {
      this.setValue(value);
    },
    idEsporte(value) {
      this.setOptions();
    },
    reload: function (value) {
      this.setOptions(value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
